<template>
  <transition name="modal">
    <div class="no-print" v-if="show || modelValue" @keydown.esc="close">
      <div class="modal-wrapper">
        <div class="mask modal-mask" @click="close"></div>
        <div class="modal" :class="{
            'wide': wide,
            'footerless': !Boolean($slots['footer']),
            'headerless': !Boolean($slots['header']),
            'mac': platform().isMac
        }">

          <div class="modal-close" v-if="closable" @click="close" :class="{'mac': platform().isMac}">
            <AppIcon name="close"  />
          </div>

          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          
          <div class="modal-content" :class="{'overflow': overflow}" v-scrollable>
            <slot></slot>
          </div>

          <div class="modal-footer" v-if="$slots['footer']">
            <slot name="footer"></slot>
          </div>

          <slot name="float"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { platform } from '@/api/tools'

export default defineComponent({
  name: 'AppModal',
  emits: ['update:modelValue'],
  props: {
    show: Boolean,
    modelValue: Boolean,
    closable: Boolean,
    wide: Boolean,
    overflow: Boolean
  },
  setup(props, { emit }) {    

    function close() {
      if (!props.show && props.closable) {
        emit('update:modelValue', false)
      } 
    }

    onMounted(() => {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close()
        }
      })
    })


    return { close, platform }
  }
})
</script>

<style lang="scss">
.modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10000000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000001;
  pointer-events: none;

  .mask {
    position: absolute;
    z-index: 0;
    pointer-events: all;
    opacity: 1;
  }

  .modal {
    transition: all .2s cubic-bezier(.28,.54,.15,.99);
    border-radius: 2rem;
    position: relative;
    width: 100%;
    min-width: 30rem;
    max-width: 16rem;
    background: var(--color-card);
    box-shadow: var(--modal-shadow);
    pointer-events: all;
    max-height: calc(100vh - 1rem);
    max-height: 50rem;
    display: flex;
    flex-direction: column;

    &.headerless {
      .modal-content {
        padding-top: 2rem;
      }
    }
    &.footerless {
      .modal-content {
        padding-bottom: 2rem;
      }
    }
    &.mac {
      .modal-header h2 {
        text-align: center !important;
      }
    }
    &-header {
      h2 {
        text-align: center;
        margin: 1rem 2rem;
      }
    }

    &-content {
      //max-height: calc(100vh - 22rem);
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 36rem;
      padding: 0 2rem 1rem;

      &.overflow {
        overflow-y: unset;
        overflow-x: unset;
      }
    }
    &-footer {
      border-top: 1px solid var(--color-divider);
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem 2rem;

      button {
        margin-right: .5rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }

    &.wide {
      min-width: 40rem;
    }

    &-close {
      position: absolute;
      cursor: pointer;
      top: 1rem;
      right: 1.25rem;
      margin: 0rem;
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10;

      &.mac {
        right: auto;
        top: 1rem;
        left: 1rem;
        
        .icon {
          background: #ED655A;
          color: transparent;
          height: 1rem;
          width: 1rem;
          font-size: .75rem;
          &:hover {
            color: #7E0508;
          }
        }

        &:after, &:before {
          content: "";
          height: 1rem;
          width: 1rem;
          border-radius: 1rem;
          background: var(--color-divider);
          position: absolute;
          top: .25rem;
          pointer-events: none;
        }

        &:after { left: 1.75rem; }
        &:before { left: 3.25rem; opacity: 0.5; }
      }
    }
  }
}

@media only screen and (max-width: 640px) {
  .modal-wrapper {
    .modal {
      min-width: 30rem !important;

      &-content {
        max-height: unset;
      }
    }
  }
}
@media only screen and (max-width: 480px) {
  .modal-wrapper {
    align-items: flex-end;
    .modal {
      min-width: unset !important;
      max-width: unset !important;
      width: 100%;
      margin-top: 10rem;
      height: 90vh;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      min-height: 16rem;

      &-content {
        padding: 0 1rem 2rem;
      }
    }
  }
}
</style>